import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getLlmServices, getServices, getSttServices, getTtsServices } from './api';
import { ServicesResponse } from './types';

export function useGetServices(options?: UseQueryOptions<{ data: ServicesResponse }, Error>) {
  return useQuery<{ data: ServicesResponse }>({
    queryKey: ['services'],
    queryFn: () => getServices(),
    ...options
  });
}

export function useGetSttServices(options?: UseQueryOptions<{ data: string[] }, Error>) {
  return useQuery<{ data: string[] }>({
    queryKey: ['stt_services'],
    queryFn: () => getSttServices(),
    ...options
  });
}

export function useGetTtsServices(options?: UseQueryOptions<{ data: string[] }, Error>) {
  return useQuery<{ data: string[] }>({
    queryKey: ['tts_services'],
    queryFn: () => getTtsServices(),
    ...options
  });
}

export function useGetLlmServices(options?: UseQueryOptions<{ data: string[] }, Error>) {
  return useQuery<{ data: string[] }>({
    queryKey: ['llm_services'],
    queryFn: () => getLlmServices(),
    ...options
  });
}
